export enum EnthusiasticToneConfig {
    ENTHUSIASTIC = "ENTHUSIASTIC",
    NEUTRAL = "NEUTRAL"
}

export enum PersonalisationConfig {
    LOW_PERSONALISATION = "LOW_PERSONALISATION",
    HIGH_PERSONALISATION = "HIGH_PERSONALISATION"
}

export enum PersuasiveToneConfig {
    PERSUASIVE = "PERSUASIVE",
    INFORMATIVE = "INFORMATIVE"
}

export enum ProfessionalismToneConfig {
    PROFESSIONAL = "PROFESSIONAL",
    FRIENDLY = "FRIENDLY"
}

export enum UrgencyToneConfig {
    URGENT = "URGENT",
    NON_URGENT = "NON_URGENT"
}

export enum EmailLength {
    SINGLE_PARAGRAPH = "SINGLE_PARAGRAPH",
    MULTI_PARAGRAPH = "MULTI_PARAGRAPH",
    MICRO_EMAIL = "MICRO_EMAIL"
}

export enum OpportunitySetting {
    RATE_CALCULATOR = "Rate Reduction",
    EQUITY_CASH_OUT = "Cash Out",
    SAVINGS = "Payment Savings",
    EQUITY_RATE_AND_TERM_REFINANCE = "Equity Growth",
    TRIGGER_LEADS = "Credit Trigger"
}

